import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette, kBiPaletteNames } from '@euler/model/bi/viz';
import { Check } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';
import { BiPaletteSwatch } from '../../components/ui/BiPaletteSwatch';

/** One palette to choose: its name and its colors. */
export const PaletteOption = memo(
  ({
    palette,
    selected,
    disabled,
    onPress,
  }: {
    palette: BiPalette;
    selected: boolean;
    disabled?: boolean;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <Pressable
        accessibilityRole="radio"
        accessibilityLabel={`配色「${kBiPaletteNames[palette]}」`}
        accessibilityState={{ checked: selected, disabled: !!disabled }}
        disabled={disabled}
        onPress={onPress}
        style={({ pressed }) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(12),
          paddingHorizontal: rpx(14),
          paddingVertical: rpx(12),
          borderRadius: rpx(12),
          borderWidth: 1,
          borderColor: selected ? aiColors.primary : aiColors.border,
          backgroundColor: selected
            ? tint(aiColors.primary, 0.06)
            : aiColors.card,
          opacity: pressed ? 0.75 : 1,
        })}
      >
        <Typography.Text
          family={selected ? 'medium' : 'regular'}
          size={rpx(13)}
          color={aiColors.foreground}
          style={{ width: rpx(44) }}
        >
          {kBiPaletteNames[palette]}
        </Typography.Text>
        <View style={{ flex: 1 }}>
          <BiPaletteSwatch palette={palette} size={14} />
        </View>
        {selected ? <Check size={16} color={aiColors.primary} /> : null}
      </Pressable>
    );
  },
);
